import React from 'react';
import { useTranslation } from 'react-i18next';

const pagenotfound = { textAlign: "center" }
const pagenotfoundP = { fontSize: "72px", fontWeight: "bold" }

const AccessDenied = (props) => {

    const { t } = useTranslation();

    return (
        <div style={pagenotfound}>
            <h1>{t('errors.accessdenied')}</h1>
            <p style={pagenotfoundP}>403</p>
        </div>
    );

}

export default AccessDenied;
